import { useState } from "react";
import { TableHeading } from "@/components/Table";
import type { Action } from "@/components/MenuButton";
import { useCanManageTasksBool } from "@/hooks/useCapabilities";
import useTasksQuery from "../_hooks/useTasksQuery";
import TasksTable from "./TasksTable";
import CreateGlobalTaskSideSheet from "@/layouts/AppLayout/CreateGlobalTask/CreateGlobalTaskSideSheet";
import type { TaskAnalyticsSource } from "../_utils/amplitude";

interface TasksTabContentProps {
  heading?: string;
  body?: string;
  source: TaskAnalyticsSource;
  queryOptions?: {
    fixedDepartment?: string;
    fixedUserId?: string;
    myTasks?: boolean;
    useTeamTagForDepartment?: boolean;
    showUnassignedChip?: boolean;
  };
  hideUserChips?: boolean;
  hideAssigneeColumn?: boolean;
}

export default function TasksTabContent({
  heading,
  body,
  source,
  queryOptions,
  hideUserChips,
  hideAssigneeColumn
}: TasksTabContentProps) {
  const canManageTasks = useCanManageTasksBool();
  const [addTaskOpen, setAddTaskOpen] = useState(false);

  const queryState = useTasksQuery(queryOptions);

  const pageActions: Action[] = canManageTasks
    ? [{ text: "Add Task", iconName: "add", onClick: () => setAddTaskOpen(true) }]
    : [];

  function handleClearAllFilters() {
    queryState.clearSearch();
    queryState.setStage(undefined);
    queryState.setDepartment(undefined);
    queryState.setAssignedToMe(false);
    queryState.setCreatedByMe(false);
    queryState.setOverdue(false);
    queryState.setUnassigned(false);
    queryState.setDueBy(undefined);
  }

  return (
    <div className="w-full">
      {heading || body ? <TableHeading heading={heading} body={body} /> : <div className="pt-12" />}
      <TasksTable
        {...queryState}
        actions={pageActions}
        onClearAllFilters={handleClearAllFilters}
        hideUserChips={hideUserChips}
        hideAssigneeColumn={hideAssigneeColumn}
        source={source}
      />
      <CreateGlobalTaskSideSheet sidebarOpen={addTaskOpen} setSidebarOpen={setAddTaskOpen} source={source} />
    </div>
  );
}
